@import '../../styles/palette.scss';
@import '../../styles/mixins.scss';
@import '../../styles/fonts.scss';

.alpBaseModal {
  background: _palette(modal-bg-secondary);
  border-radius: 5px;
  margin: 2em auto;
  min-width: 30em;
  padding: 1em;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  position: relative;

  &:focus {
    outline: none;
  }

  .cancelButton {
    position: absolute;
    right: 1em;
    top: 1em;
  }

  .alpModalHeader {
    display: flex;
    border-bottom: solid 0.1em _palette(border-strong);
    padding: 0 3em 0.3em 0;
    flex: 0;
    align-items: center;

    .titlesAndIcon {
      display: inline-flex;
      align-items: center;
      margin-bottom: 0.5em;

      .titleIcon {
        color: _palette(secondary);
        height: 2.8em;
        width: 2.8em;
      }

      .titles {
        margin: 0 0.75em;

        .title {
          @include merriweather(20);
          line-height: 1.75rem;
        }

        .subtitle {
          @include barlow(14);
          line-height: 1rem;
        }
      }
    }
  }

  .alpModalContents {
    padding: 1.25em 1.875em 3em;
    border-bottom: solid 0.1em _palette(modal-left-border-primary);
    overflow-y: auto;
    flex: 1 1 auto;

    & > p {
      @include barlow(16);
      margin: auto;
      max-width: 30em;

      + p {
        margin-top: 1em;
      }
    }
  }

  .alpModalFooter {
    display: flex;
    padding: 1em 0;
    width: 100%;
    flex: 0;

    .checkbox {
      flex: 1 1 auto;
    }

    .buttonContainer {
      display: flex;
      width: inherit;
      justify-content: flex-end;
      flex: 1 auto;
      gap: 1em;
      flex-wrap: wrap;
    }
  }
}

.icon {
  color: _palette(secondary);
  height: 2.8em !important;
  width: 2.8em !important;
}
